;(function($, window, document) {

    window.notification = {

        show: function(params) {
            var that = this;

            // Default options
            var options = {
                'showAfter': 0, // Number of seconds to wait after the page loads
                'duration': 3, // Display duration
                'autoClose': false, // Autoclose the notification
                'type': 'success', // Type of message: success/error/warning/info
                'message': '' // The notification message
            };

            // Extend the array from the parameters
            $.extend(true, options, params);

            var msgclass = 'notification-' + options['type'] || 'notification-success';
            var icon = '';

            switch (options['type']) {
                case 'success':
                    icon = 'check';
                    break;
                case 'error':
                    icon = 'times-circle';
                    break;
                case 'warning':
                    icon = 'warning';
                    break;
                case 'info':
                    icon = 'info';
                    break;
                default:
                    icon = 'info';
            }

            // Notification div
            var container = '<div class="notification-message ' + msgclass + '">';
            container += '<i class="fa fa-' + icon + '"></i>';
            container += '<div class="notification-message-text">' + options['message'];
            container += '</div></div>';

            var $notification = $(container);

            // Append the notification to the body
            $('body').append($notification);
            
            var $notificationMessage = $('div.notification-message');

            var divHeight = $notificationMessage.height();

            $notificationMessage.css({
                top: '-' + divHeight + 'px'
            });

            // Show the notification message
            $notificationMessage.show();

            // Slide down notification message after startAfter seconds
            this.slideDown(options['showAfter'], options['autoClose'], options['duration']);

            $notification.on('click', function () {
                that.close();
            });

            return this;
        },

        close: function (duration) {
            var divHeight = $('div.notification-message').height();

            setTimeout(function () {
                $('div.notification-message').animate({
                    top: '-' + divHeight
                });

                // Delete the notification div from the body
                setTimeout(function () {
                    $('div.notification-message').remove();
                }, 1000);
            }, parseInt(duration * 1000));

            return this;
        },

        slideDown: function (startAfter, autoClose, duration) {
            var that = this;

            setTimeout(function() {
                $('div.notification-message').animate({
                    top: 0
                });

                if (autoClose) {
                    setTimeout(function() {
                        that.close(duration);
                    }, duration);
                }
            }, parseInt(startAfter * 1000));

            return this;
        }
    }

})(jQuery, window, document);